import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { KeyRound } from 'lucide-react';
import { Button } from '../components/ui/button';
import { API, useAuth } from '../context/AuthContext';
import { AuthCard, Field, ErrorBox, formatApiError } from '../components/auth/AuthCard';
import { toast } from '../hooks/use-toast';

export default function ChangePasswordPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const hasPassword = user?.auth_providers?.includes('password');
  const [current, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (loading) return null;
  if (!user) return <Navigate to="/login?next=/change-password" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) return setError('ପାସୱାର୍ଡ ଅତି କମରେ ୮ ଅକ୍ଷର ହେବା ଦରକାର / Min 8 characters');
    if (password !== confirm) return setError('ଦୁଇଟି ପାସୱାର୍ଡ ମେଳ ଖାଉନାହିଁ / Passwords do not match');
    setBusy(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: hasPassword ? current : null, new_password: password }, { withCredentials: true });
      toast({ title: hasPassword ? 'ପାସୱାର୍ଡ ବଦଳିଗଲା' : 'ପାସୱାର୍ଡ ସେଟ୍ ହେଲା', description: 'ଏବେ ଇମେଲ୍ + ପାସୱାର୍ଡ ସହ ମଧ୍ୟ ଲଗଇନ୍ କରିପାରିବେ' });
      navigate('/profile', { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <AuthCard title={hasPassword ? 'ପାସୱାର୍ଡ ବଦଳାନ୍ତୁ' : 'ପାସୱାର୍ଡ ସେଟ୍ କରନ୍ତୁ'}
      subtitle={hasPassword ? 'ନିରାପତ୍ତା ପାଇଁ ନିୟମିତ ପାସୱାର୍ଡ ବଦଳାନ୍ତୁ' : 'Google ବିନା ମଧ୍ୟ ଲଗଇନ୍ କରିବାକୁ ଏକ ପାସୱାର୍ଡ ସେଟ୍ କରନ୍ତୁ'}>
      <form onSubmit={submit} className="space-y-3" data-testid="change-password-form">
        {hasPassword && (
          <Field label="ବର୍ତ୍ତମାନର ପାସୱାର୍ଡ / Current" type="password" required autoComplete="current-password" testId="change-current-password-input"
            value={current} onChange={e => setCurrent(e.target.value)} placeholder="••••••••" />
        )}
        <Field label="ନୂଆ ପାସୱାର୍ଡ / New password" type="password" required autoComplete="new-password" testId="change-new-password-input"
          value={password} onChange={e => setPassword(e.target.value)} placeholder="ଅତି କମରେ ୮ ଅକ୍ଷର" />
        <Field label="ପୁଣି ଲେଖନ୍ତୁ / Confirm" type="password" required autoComplete="new-password" testId="change-confirm-password-input"
          value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="••••••••" />
        <ErrorBox message={error} testId="change-password-error" />
        <Button type="submit" disabled={busy} data-testid="change-password-submit-button"
          className="w-full h-12 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold gap-2">
          <KeyRound size={16} /> {busy ? 'ଅପେକ୍ଷା କରନ୍ତୁ…' : 'ସେଭ୍ କରନ୍ତୁ'}
        </Button>
      </form>
    </AuthCard>
  );
}
